var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9ab2a7ac8e668ff030dbf5119f1ef4b71a58d69c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["prom@nicholas-gregory"]={id:"9ab2a7ac8e668ff030dbf5119f1ef4b71a58d69c"};
      